module.exports = __webpack_public_path__ + "static/media/Feeds.6762124f.svg";